export default {
  namespaced: true,
  state: {
    showAudio: false,
    id: '',
    src: 'https://yj-file-ch.oss-cn-shanghai.aliyuncs.com/pdf/voice/132cc7r8hu.wav',
    title: "中俄两国领导人举行双边会见，就中俄关系和共同关心的国际和地区问题交换意见",
    time: 0,
    speed: 2,
    duration:"",
    list: {}//包含time、speed
  },
  getters: {
    showAudio: state => state.float.showAudio,
    id: state => state.float.id,
    src: state => state.float.src,
    title: state => state.float.title,
    time: state => state.float.time,
    speed: state => state.float.speed,
    list: state => state.float.list,
    duration: state => state.float.duration
  },
  mutations: { //同步的更改数据
    setAudio(state, showAudio) {
      state.showAudio = showAudio
    },
    setId(state, id) {
      state.id = id
    },
    setSrc(state, src) {
      state.src = src
    },
    setTitle(state, title) {
      state.title = title
    },
    setTime(state, time) {
      state.time = time
    },
    setSpeed(state, speed) {
      state.speed = speed
    },
    setList(state, list) {
      state.list = list
    },
    setDuration(state, duration) {
      state.duration = duration
    },
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/float.js